'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dCuisine from "./mealorama.-Cuisine.js";
var $p;
/** @constructor */
function $c_Lmealorama_Cuisine$() {
}
export { $c_Lmealorama_Cuisine$ as $c_Lmealorama_Cuisine$ };
$p = $c_Lmealorama_Cuisine$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Cuisine$;
/** @constructor */
function $h_Lmealorama_Cuisine$() {
}
export { $h_Lmealorama_Cuisine$ as $h_Lmealorama_Cuisine$ };
$h_Lmealorama_Cuisine$.prototype = $p;
$p.m = (function() {
  return "Cuisine";
});
$p.aSc = (function(x$0) {
  return new $j_mealorama$002e$002dCuisine.$c_Lmealorama_Cuisine(x$0.g(0));
});
var $d_Lmealorama_Cuisine$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Cuisine$, "mealorama.Cuisine$", ({
  FJ: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Cuisine$ as $d_Lmealorama_Cuisine$ };
var $n_Lmealorama_Cuisine$;
function $m_Lmealorama_Cuisine$() {
  if ((!$n_Lmealorama_Cuisine$)) {
    $n_Lmealorama_Cuisine$ = new $c_Lmealorama_Cuisine$();
  }
  return $n_Lmealorama_Cuisine$;
}
export { $m_Lmealorama_Cuisine$ as $m_Lmealorama_Cuisine$ };
//# sourceMappingURL=mealorama.-Cuisine$.js.map
